<template>
  <div class="subTabClass" v-if="chartData1 !== null && chartData1.length">
    <PlotlyMultiLineChart
      class="svgChart"
      :data-set="chartData1"
      :xAxisType="'date'"
      :yAxisType="yAxisType"
      :margin="margin"
      :title="chartTitle"
      :name="name"
      :chartWidth="chartWidth"
      :chartHeight="chartHeight" 
      :tickFormat="tickFormat"
      :commitName="'Recession Criteria: Change vs. End Of last Recession'"
    >
    </PlotlyMultiLineChart>
    
  </div>
</template>
<script>
//------------Import Charts----------
import PlotlyMultiLineChart from "@/components/charts/PlotlyCharts/MultiLineChart.vue";
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
export default {
  name: "recessioncriteriachangevsendoflastrecession",
  components: {
    PlotlyMultiLineChart,
  },
  computed: {
   ...mapGetters({
      recessioncriteria: "recessioncriteriachangevsendoflastrecession",
      historyCalDropDown: "historyCalDropDown",
    }),
  },
  data() {
    return {
      chartTitle: "",
      name: "Recession Criteria Change vs. End of Last Recession",
      yAxisType: "linear",
      xAxisType: "date",
      chartWidth: 1250,
      chartHeight: 330,
      tickFormat:"",
      chartData1: null,
      margin: {
        l: 80,
        r: 80,
        b: 120,
        t: 40,
        pad: 2,
      },
    };
  },
  created() {
    this.getChartData();
  },
  methods: {
    ...mapActions(["getIframeChartDataById", "currentVersionUpdateHandler"]),
    unpack(rows, key) {
      return rows.map(function (row) {
        return row[key];
      });
    },

    async getChartData() {
      //------------Formatted Data------------
      // d.IP_mfg = +d.IP_mfg;
			// 		d.real_retail_sales = +d.real_retail_sales;
			// 		d.real_PCE = +d.real_PCE;
			// 		d.real_PCE_ex_transfer = +d.real_PCE_ex_transfer;
			// 		d.employment = +d.employment;
      let chart_API_Data = [];
      if (window.location.href.includes("auth_token=") && !this.recessioncriteria.length) {
        let data = await this.getIframeChartDataById(10);
        // console.log("iframeAPICallById__QQQ", data);
        chart_API_Data = data;
      } else {
        chart_API_Data = this.recessioncriteria;
      }
      //------------Formatted Data------------
      if(chart_API_Data && chart_API_Data.length){
      // console.log('this.recessioncriteria-=-=', chart_API_Data);
      let formattedData = chart_API_Data.map(function (i) {
        // console.log("ddddddddddddddddddddddddddddd", i.date)
        return {
          lineField: +i.ip_mfg,
          lineField1: +i.real_retail_sales,
          lineField2: +i.real_pce_ex_transfer,
          lineField3: +i.employment,
          lineField4:+i.real_pce,
          xField: i.date,
          year: moment(i.date).format('YYYY')
        };
      });

     // formattedData.reverse();
      // console.log('formatted data-=-==',formattedData);
      //------------Line Charts------------
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "Employment",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField3"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#68b9d3",
          dash: "dash"
        },
      };

      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "Real PCE-Ex Transfer",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField2"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#939090",
        },
      };

      let trace3 = {
        type: "scatter",
        mode: "lines",
        name: "Real Retail Sales",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#C8D6CA",
        },
      };

      let trace4 = {
        type: "scatter",
        mode: "lines",
        name: "IP - Mfg.",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField4"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#bcb0cf",
        },
      };

      let trace5 = {
        type: "scatter",
        mode: "lines",
        name: "Real PCE",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#f2be6d",
          dash: "dash"
        },
      };
      setTimeout(() => {
        if (trace1 && trace2 && trace3 && trace4 && trace5) {
          this.chartData1 = [trace1, trace2,trace3,trace4,trace5];
        }
      }, 10);
    }
    },
  },
  watch: {
    recessioncriteria: {
        deep: true,
        handler() {
          this.chartData1 = null;
          this.getChartData();
          // this.loadChartData();
          // console.log("api responceeeeeeeeeeee", this.sectorValuations);
        }
    }
  },
  destroyed() {
    // console.log("destroyed++++", this.commitName);
    let payLoadObj = {
      table_pk: this.selected,
      chart_id: this.historyCalDropDown.current_version.chart_id,
      chartName: this.commitName,
    };
    let version = {
      version_data: payLoadObj,
      versionToggleValue: false,
    };
    this.currentVersionUpdateHandler(version);
  },
};
</script>
